export default {
  "verticalBadgeLine": "_verticalBadgeLine_epkbj_13",
  "horizontalBadgeLine": "_horizontalBadgeLine_epkbj_18",
  "lineBeforeBadge": "_lineBeforeBadge_epkbj_26",
  "lineAfterBadge": "_lineAfterBadge_epkbj_31",
  "horizontalDashedLine": "_horizontalDashedLine_epkbj_36",
  "verticalDashedLine": "_verticalDashedLine_epkbj_45",
  "solidBlueLine": "_solidBlueLine_epkbj_55",
  "pulse": "_pulse_epkbj_59",
  "pulsingAnimation": "_pulsingAnimation_epkbj_1",
  "pulseRed": "_pulseRed_epkbj_78"
};import "ni:sha-256;yYvGWkR3FgSqixdfLAiw0qs49b8czMW3eTV8w8LOkGk";